import React from 'react';
import BoxWithShadow from './BoxWithShadow';
import CSVDownloadMenu from '../reporting-components/CSVDownloadMenu';

export default function SidebarTitle(props) {
  return (
    <BoxWithShadow tenant={props.tenant}>
      <div id="sidebar-title-component" className="sidebar-title-component">
        <div className="sidebar-title-component__title-container">
          <p className="sidebar-title-component__title">{props.title}</p>
        </div>
        <div className="sidebar-title-component__children">
          {props.children}
        </div>
        <div className="sidebar-title-component__meatball-container">
          <CSVDownloadMenu csv={props.csvCallback} filename={props.csvTitle} />
        </div>
      </div>
    </BoxWithShadow>
  );
}
